<template>
  <Layout>
    <div style="width: 100%; margin-top: 55px">
      <q-card v-if="vehicles.length === 0 && !loading">
        <empty-value name="vehicle" style="background: #fff !important"></empty-value>
      </q-card>
      <div id="table-scroll" ref="tablev2" class="table-scroll">
        <q-btn v-if="vehicles.length > 0" class="glossy custom-item-icon-3 left-0" style="margin-left: -10px"
          @mousedown="shiftLeft()" @mouseup="shiftLeftEnd()" round color="primary" icon="fas fa-arrow-left" />
        <q-btn v-if="vehicles.length > 0" class="glossy custom-item-icon-3 right-0" @mouseup="shiftRightEnd()"
          @mousedown="shiftRight()" round color="primary" icon="fas fa-arrow-right" />
        <table id="main-table" class="main-table shadow-2" v-if="vehicles.length > 0">
          <draggable v-bind="dragOptions" @start="drag = true" @end="drag = false" v-model="columns" tag="thead">
            <transition-group class="head-tr" tag="tr" type="transition" :name="drag ? 'flip-list' : null">
              <th :style="visibleColumns.some(item => item.name === col.name) ? 'display:table-cell' : 'display:none'"
                style="cursor: all-scroll;" v-for="col in columns" @click="sortTable(col.val)" :key="col.val" scope="col">
                <div>
                  {{ col.name }}
                  <i v-if="sort.name && col.val === sort.name"
                    :class="sort.count % 2 === 1 ? 'fas fa-arrow-down' : 'fas fa-arrow-up'" style="font-size: 12px"></i>
                </div>
              </th>
            </transition-group>
          </draggable>
          <transition-group name="flip-list" tag="tbody">
            <tr class="hoverable-tr" v-for="item in vehicles" :key="item.id">
              <td v-for="header in columns" :key="header.val" :style="rowStyle(item)">
                <div v-if="header.val === 'unit' || header.val === 'vin' || header.val === 'location' ||
                  header.val === 'brand' || header.val === 'model' || header.val === 'model_year' ||
                  header.val === 'class_name'">
                  {{
                    typeof item[header.val] == 'object'
                    ? item[header.val] && item[header.val].name
                      ? item[header.val].name
                      : '-'
                    : item[header.val]
                  }}
                </div>
                <div v-else-if="header.val === 'condition'" v-html="getConditionName(item[header.val])"></div>
                <div v-else-if="header.val === 'mileage'"
                  v-html="item[header.val] ? item[header.val].toLocaleString('en-US') : '-'"></div>
                <div v-else-if="header.val === 'class_utilization'"
                  v-html="item[header.val] ? item[header.val] + '%' : '-'"></div>
                <div v-else-if="header.val === 'class_rpu' || header.val === 'class_t_m' ||
                  header.val === 'depreciation_assumption' || header.val === 'diff_rpu_assumption'"
                  v-html="item[header.val] ? toCurrency(item[header.val]) : '-'"></div>
                <div v-else-if="header.val === 'auction' || header.val === 'payoff' || header.val === 'revenue' ||
                  header.val === 'monthly_payment'" v-html="toCurrency(item[header.val])"></div>
                <div v-else-if="header.val === 'status'" v-html="getLabelByValue(item[header.val])"></div>
              </td>
            </tr>
          </transition-group>
        </table>
      </div>
      <div class="loading-infinite" v-if="loading">
        <div>
          <q-spinner-facebook color="primary" size="40px" />
          <div class="text-grey-7">Loading</div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import draggable from 'vuedraggable'
import Layout from '../components/Layout'
import Vehicle from '../components/Vehicle'
import VehicleTable from '../components/VehicleTable'
import Loading from '../components/Loading'
import axios from '../axios/index'
import { getLabelByValue } from "@/enums";
import capitalizeFirstLetter from "@/helper/capitalizeFirstLetter";
import toCurrency from "@/helper/toCurrency";
import EmptyValue from "@/components/EmptyValue.vue";

export default {
  components: {
    EmptyValue,
    Loading,
    Vehicle,
    Layout,
    VehicleTable,
    draggable
  },
  data() {
    return {
      rightInterval: null,
      leftInterval: null,
      conditions: [
        {
          name: 'Above',
          val: 'excellent'
        },
        {
          name: 'Average',
          val: 'good'
        },
        {
          name: 'Below',
          val: 'fair'
        }
      ],
      drag2: false,
      drag: false,
      sort: {
        name: '',
        count: 0
      },
      columns: [
        {
          name: 'UNIT',
          val: 'unit'
        },
        {
          name: 'VIN',
          val: 'vin'
        },
        {
          name: 'LOCATION',
          val: 'location'
        },
        {
          name: 'BRAND',
          val: 'brand'
        },
        {
          name: 'MODEL',
          val: 'model'
        },
        {
          name: 'MODEL YEAR',
          val: 'model_year'
        },
        {
          name: 'CLASS NAME',
          val: 'class_name'
        },
        {
          name: 'CONDITION',
          val: 'condition'
        },
        {
          name: 'MILEAGE',
          val: 'mileage'
        },
        {
          name: 'CLASS UTILIZATION',
          val: 'class_utilization'
        },
        {
          name: 'CLASS RPU',
          val: 'class_rpu'
        },
        {
          name: 'CLASS T&M',
          val: 'class_t_m'
        },
        {
          name: 'RPU - DEPR. ASSM.',
          val: 'diff_rpu_assumption'
        },
        {
          name: 'DEPRECIATION ASSUMPTION',
          val: 'depreciation_assumption'
        },
        {
          name: 'AUCTION VALUE',
          val: 'auction'
        },
        {
          name: 'ESTIMATED PAYOFF',
          val: 'payoff'
        },
        {
          name: 'ESTIMATED REV/LOSS',
          val: 'revenue'
        },
        {
          name: 'MONTHLY PAYMENT',
          val: 'monthly_payment'
        },
        {
          name: 'STATUS',
          val: 'status'
        }
      ]
    }
  },
  metaInfo() {
    return {
      title: 'Adjustment of Current Fleet information | FMS',
      meta: [
        {
          name: 'description',
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: 'Adjustment of Current Fleet information'
        },
        {
          property: 'og:title',
          content: 'Adjustment of Current Fleet information | FMS'
        },
        { property: 'og:site_name', content: 'FMS' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  async mounted() {
    this.$store.state.vehicleClassPerformance.vehicles.length === 0 ? await this.getVehicleClassPerformance() : ''
    this.$store.state.vehicleClassPerformance.groups.length === 0 ? await this.getVehicleGroups() : ''
    this.$store.state.tag.tags.length === 0 ? await this.getTags() : ''
  },
  created() {
    setTimeout(() => {
      document.querySelector('.scroll').addEventListener('scroll', this.onScroll)
    }, 1000)
  },
  destroyed() {
    document.querySelector('.scroll').removeEventListener('scroll', this.onScroll)
  },
  methods: {
    toCurrency,
    capitalizeFirstLetter,
    getLabelByValue,
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    rowStyle(item) {
      return item.revenue < 0 ? 'background: rgba(244, 67, 54, 0.1);' : 'background: rgba(76, 175, 80, 0.1);';
    },
    sortTable(row) {
      this.sort.name === row ? this.sort.count++ : ''
      this.sort.name = row
      const order = this.sort.count % 2 === 0 ? 'asc' : 'desc'
      const deep = [...this.vehicles]
      this.vehicles = deep.sort(this.sortVehicles(row, order))
    },
    sortVehicles(key, order) {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0
        }

        var varA, varB
        if (typeof a[key] === 'string') {
          varA = a[key] ? a[key].toUpperCase() : ''
        } else {
          varA = a[key]
        }

        if (typeof b[key] === 'string') {
          varB = b[key] ? b[key].toUpperCase() : ''
        } else {
          varB = b[key]
        }

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return order === 'desc' ? comparison * -1 : comparison
      }
    },
    async getVehicleGroups() {
      const { data } = await axios.get('vehicle-groups')
      this.groups = data.data
    },
    async getTags() {
      try {
        const { data } = await axios.get('vehicle-tags')
        this.tags = data.data
      } catch (error) {
      }
    },
    onScroll(e) {
      const obj = e.target
      if (obj.scrollTop >= obj.scrollHeight - obj.offsetHeight - 100) {
        if (this.vehicles.length !== 0 && !this.loading) {
          this.page++
          this.getVehicleClassPerformance()
        }
      }
    },
    async getLocations(companyId) {
      if (companyId) {
        try {
          const params = { company_id: companyId }
          const { data } = await axios.get(`locations`, { params })
          this.locations = data.data
        } catch (error) {
        } finally {
        }
      }
    },
    resetter() {
      this.page = 1
      this.lastPage = 100
      this.vehicles = []
      this.loading = true
      setTimeout(() => {
        this.getVehicleClassPerformance()
      }, 50)
    },
    async getVehicleClassPerformance() {
      if (this.page > this.lastPage && !this.loading) {
        return false
      }
      this.loading = true
      const { params } = this.queryBuilder()
      const { data } = await axios.get('/vehicle-analysis/class-performance', { params })
      this.loading = false
      const { last } = data.data.pagination
      this.lastPage = last

      let deep = () => {
        if (this.page === 1) {
          return data.data.items.map(item => ({
            id: item.id,
            unit: item.unit,
            vin: item.vin,
            location: item.location.name,
            brand: item.brand ? item.brand.name : '-',
            model: item.model ? item.model.name : '-',
            model_year: item.model_year,
            class_name: item.class_name,
            condition: item.condition,
            mileage: item.last_mileage_record?.mileage,
            class_utilization: item.class_performance?.utilization,
            class_rpu: item.class_performance?.revenue_per_unit,
            class_t_m: item.class_performance?.average_time_and_mileage,
            diff_rpu_assumption: item.class_performance?.revenue_per_unit - item.depreciation_assumption,
            depreciation_assumption: item.depreciation_assumption,
            auction: item.auction,
            payoff: item.payoff,
            revenue: item.revenue,
            monthly_payment: item.monthly_payment,
            status: item.status,
          }))
        } else {
          let carbon = [...this.vehicles]
          let nextPage = data.data.items.map(item => ({
            id: item.id,
            unit: item.unit,
            vin: item.vin,
            location: item.location.name,
            brand: item.brand ? item.brand.name : '-',
            model: item.model ? item.model.name : '-',
            model_year: item.model_year,
            class_name: item.class_name,
            condition: item.condition,
            mileage: item.last_mileage_record?.mileage,
            class_utilization: item.class_performance?.utilization,
            class_rpu: item.class_performance?.revenue_per_unit,
            class_t_m: item.class_performance?.average_time_and_mileage,
            diff_rpu_assumption: item.class_performance?.revenue_per_unit - item.depreciation_assumption,
            depreciation_assumption: item.depreciation_assumption,
            auction: item.auction,
            payoff: item.payoff,
            revenue: item.revenue,
            monthly_payment: item.monthly_payment,
            status: item.status,
          }))
          return carbon.concat(nextPage)
        }
      }
      this.vehicles = deep()
    },
    queryBuilder() {
      const params = { page: this.page, per: 20 }
      if (this.companyFilter.id) params.company_id = this.companyFilter.id
      if (this.search) params.q = this.search
      if (this.tagQ.length > 0) params.tag_id = this.tagQ.map(item => item.id)
      if (this.statusQ.length > 0) params.statuses = this.statusQ.map(item => item.value)
      if (this.multiFilter.length > 0) params.location_id = this.multiFilter.map(item => item.id)
      return { params }
    },
    getConditionName(val) {
      return this.conditions.find(item => item.val === val).name
    }
  },
  computed: {
    tagQ: {
      get() {
        return this.$store.state.vehicleClassPerformance.tagQ
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_TAG_Q', val)
      }
    },
    statusQ: {
      get() {
        return this.$store.state.vehicleClassPerformance.statusQ
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_STATUS_Q', val)
      }
    },
    randomColorGenerator() {
      return (color, index) => {
        if (index === 0 || index === 1) return `background:${color}`
        else if (index === 2) return 'background:#F2C037'
        else return 'display:none'
      }
    },
    tags: {
      get() {
        return this.$store.state.tag.tags
      },
      set(val) {
        this.$store.commit('tag/SET_TAGS', val)
      }
    },
    tagOperation: {
      get() {
        return this.$store.state.vehicleClassPerformance.tagOperation
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_TAG_OPERATION', val)
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    visibleColumns() {
      return this.$store.state.vehicleClassPerformance.visibleColumns
    },
    groups: {
      get() {
        return this.$store.state.vehicleClassPerformance.groups
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_GROUPS', val)
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.vehicleClassPerformance.multiFilter
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_MULTI_FILTER', val)
      }
    },
    locationFilter: {
      get() {
        return this.$store.state.vehicleClassPerformance.locationFilter
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_LOCATION_FILTER', val)
      }
    },
    lastPage: {
      get() {
        return this.$store.state.vehicleClassPerformance.lastPage
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_LAST_PAGE', val)
      }
    },
    page: {
      get() {
        return this.$store.state.vehicleClassPerformance.page
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_PAGE', val)
      }
    },
    loading: {
      get() {
        return this.$store.state.vehicleClassPerformance.loading
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_LOADING', val)
      }
    },
    vehicles: {
      get() {
        return this.$store.state.vehicleClassPerformance.vehicles
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_VEHICLES', val)
      }
    },
    locations: {
      get() {
        return this.$store.state.vehicleClassPerformance.locations
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_LOCATIONS', val)
      }
    },
    companyFilter: {
      get() {
        return this.$store.state.vehicleClassPerformance.companyFilter
      },
      set(val) {
        this.$store.commit('vehicleClassPerformance/SET_COMPANY_FILTER', val)
      }
    },
    gridType() {
      return this.$store.state.vehicleClassPerformance.grid
    },
    search() {
      return this.$store.state.vehicleClassPerformance.search
    }
  },
  watch: {
    tagQ: {
      deep: true,
      handler(n, o) {
        this.resetter()
      }
    },
    statusQ: {
      deep: true,
      handler(n, o) {
        this.resetter()
      }
    },
    search(n, o) {
      window.scrollTo(0, 0)
      this.resetter()
    },
    companyFilter: {
      deep: true,
      handler(n, o) {
        window.scrollTo(0, 0)
        this.multiFilter = []
        n && n.id ? this.getLocations(n.id) : ''
        this.resetter()
      }
    },
    multiFilter(n, o) {
      window.scrollTo(0, 0)
      if (this.companyFilter.id) {
        this.resetter()
      }
    }
  }
}
</script>

<style lang="scss">
.custom-item-icon-3 {
  z-index: 999 !important;
  position: fixed !important;
  top: 60% !important;
}

.right-0 {
  right: 0;
}

.table-cell {
  display: table-cell;
}

.none-cell {
  display: none;
}

.selected-finance {
  background: rgba(244, 67, 54, 0.5) !important;
}

.no-finance {
  background: rgba(244, 67, 54, 0.1) !important;
}

.tag-table-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  .tag-item {
    margin-right: -5px;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 50%;
  }
}

.mark-table {
  background: rgba(0, 0, 0, 0.12) !important;
}

.flip-list-move {
  transition: transform 500ms;
}

.hoverable-tr {
  &:hover {
    td {
      transition: 500ms all;
      background: #f7f7f7;
    }
  }
}

.table-scroll {
  position: relative;
  z-index: 1;
  overflow: auto;
}

.table-scroll table {
  width: 100%;
  min-width: 1266px;
  border-collapse: separate;
  border-spacing: 0;
}

.table-wrap {
  position: relative;
}

.table-scroll {
  th {
    align-items: center;
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
  }

  td {
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
    cursor: pointer;
  }
}

@media only screen and (max-width: 600px) {

  .table-scroll th,
  .table-scroll td {
    padding: 15px 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: left;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.container-checkbox {
  width: 18px;
  cursor: pointer;
  height: 18px;
  text-align: center;
  border: 2px solid rgba(0, 0, 0, 0.54);
}
</style>
